
import Vue from 'vue';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import GenericImageGenerator from '@owc-utils/GenericImage/GenericImageGenerator';
import { ThumbnailComponent } from './VideoPlayer';
/**
 * `VideoPlayer Thumbnail` - Contains the image when the video is stopped or not playing.
 */
export default (Vue as ThumbnailComponent).extend({
  name: 'owc-video-player-thumbnail',
  props: {
    thumbnailId: {
      type: String,
      required: false,
    },
    thumbnailData: {
      type: Object,
      required: false,
    },
  },
  components: {
    GenericImage,
  },
  computed: {
    imageData: function() {
      return this.thumbnailData ? new GenericImageGenerator(this.thumbnailData) : null;
    },
  },
});
